import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Button, Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/Delete';
import TemperatureEquipment from './TemperatureEquipment';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';

export function ShowHoldingProfileEquipment({
  holdingProfile,
  handleRemove,
  index,
  title,
  readOnly = false,
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <>
      {holdingProfile.availabilities.map((profile, indexProfile) => (
        <Grid key={`HP_${indexProfile}`} container>
          <Grid item xs={4} className={classes.separation}>
            <Typography>{title}</Typography>
          </Grid>
          <Grid item xs={4} className={classes.separation}>
            <Typography>
              {`${profile?.region} ${
                profile?.country?.description !== undefined
                  ? '/ ' + profile.country.description
                  : ''
              } ${
                profile?.state?.description !== undefined
                  ? '/ ' + profile.state.description
                  : ''
              }`}
            </Typography>
          </Grid>
          {!indexProfile && (
            <Grid
              item
              xs={4}
              style={{ textAlign: 'right', marginTop: 10, marginBottom: 10 }}
            >
              <Button
                variant="outlined"
                size="small"
                disabled={readOnly}
                endIcon={<DeleteIcon />}
                onClick={handleRemove(index, holdingProfile.id)}
              >
                {t('app.common.delete')}
              </Button>
            </Grid>
          )}
          <Grid item xs={12} className={classes.separation}>
            <Divider />
          </Grid>
          <TemperatureEquipment
            profile={profile}
            name={t('commodities.initialHeatingTemperature')}
          />
          <Grid item xs={12} className={classes.separation}>
            <Divider />
          </Grid>
        </Grid>
      ))}
    </>
  );
}
